import { render, staticRenderFns } from "./wyjflist.vue?vue&type=template&id=18d495b3&"
import script from "./wyjflist.vue?vue&type=script&lang=js&"
export * from "./wyjflist.vue?vue&type=script&lang=js&"
import style0 from "./wyjflist.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports